import * as Shape from './shape';
var pkg = require('../package.json');
export var version = pkg.version;
export { Event } from '@antv/g-base';
export { default as Canvas } from './canvas';
export { default as Group } from './group';
export { Shape };
//# sourceMappingURL=index.js.map